import type { ReactQuillProps } from 'react-quill';
import ReactQuill from 'react-quill';

interface TextEditorProps extends ReactQuillProps {}

export function RichTextEditor({
  value,
  onChange,
  onBlur,
  ...props
}: TextEditorProps) {
  return (
    <ReactQuill
      theme="snow"
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      {...props}
    />
  );
}
